var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPrismaSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Calque_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 73 37"
    },
    viewBox: "0 0 73 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ff0045}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Activit\\uFFFDs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "En-ce-moment",
    transform: "translate(-14 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Logo",
    transform: "translate(14 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M63.3 36.8h9.5L63.8.2h-7.3l-6.9 20.5L42.8.2h-7.3l-9 36.6h9.3l4.2-17 5.9 17H53l6.1-17 4.2 17",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "m9.7 9.9 12.3-8C19.8.9 16.9.2 13.1.2H0v36.6h9.6V9.9",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "m23.1 2.5-12 22.3h3.5c8.3 0 13.5-4.7 13.5-12.3 0-3.6-1.1-7.6-5-10",
    className: "st0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrismaSmall);
export default __webpack_public_path__ + "static/media/logo-prisma-small.71272b32a6605362a9e817d95a2a6fe9.svg";
export { ForwardRef as ReactComponent };